import { DateTime } from 'luxon'

import { useAppContext } from '@/client/context/app'
import { PROGRAM_SLUG_TO_PROGRAM_DETAILS } from '@/client/services/programs/config'
import { PROGRAM_SLUGS_WITH_ITERATIONS } from '@/client/services/programs/constants'
import { getProgramIterationOpenForRegistration } from '@/client/services/programs/getProgramIterationHelpers'
import type { ProgramIteration } from '@/client/services/programs/types'

export type WorldSlugToProgramIteration = Record<string, ProgramIteration | null>

export default function useAllProgramIterationsOpenForRegistration({
  type,
}: {
  type: 'learner' | 'tutor'
}): WorldSlugToProgramIteration {
  const { requestTimestamp } = useAppContext()
  const now = DateTime.fromISO(requestTimestamp, { zone: 'utc' })

  const programIterationsMapEntries = PROGRAM_SLUGS_WITH_ITERATIONS.map(
    (programSlug): [string, ProgramIteration | null] => {
      const programDetails = PROGRAM_SLUG_TO_PROGRAM_DETAILS[programSlug]
      if (programDetails == null) {
        return [programSlug, null]
      }

      const openIteration = getProgramIterationOpenForRegistration(programSlug, type, now)

      return [programSlug, openIteration]
    }
  )

  return Object.fromEntries(programIterationsMapEntries)
}
